import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Loader from './services/LoaderOverlay'
import Notifications from 'vue-notification'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.use(Notifications)
Vue.use(Loader)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
